import { aboutPoints, editorialRules } from "@/mocks/chigua";

const toneChip: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

const quotes = [
  { text: "每天蹲更新，赛况速递比追连续剧还上瘾，轮次和对手从没看错过。", who: "追更观众 · 一期不落" },
  { text: "晋级数据实时刷新、战报复盘清楚，看个乐子也能看得明明白白。", who: "资深瓜友" },
  { text: "规则透明、更新准时，连每天几点对战都给你标得清清楚楚。", who: "栏目常驻观众" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14">
          {/* left: about */}
          <div>
            <p className="text-sm font-bold uppercase tracking-wide text-secondary-700">关于我们 About</p>
            <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              一个把“吃瓜”做成晋级的娱乐栏目
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              吃瓜大赛把观众最爱的“围观”变成一场有赛程、有晋级、有战报的娱乐赛事：候选瓜位分组对抗、
              观众投票决定走向、数据全程透明。我们用清晰的时间表和及时的速递，让每个追更的人都能轻松跟上节奏。
            </p>

            <ul className="mt-7 space-y-4">
              {aboutPoints.map((p) => (
                <li key={p.title} className="flex items-start gap-4">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${toneChip[p.tone]}`}
                  >
                    <i className={`text-xl ${p.icon}`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-7 rounded-3xl bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base text-foreground-950">
                <i className="ri-scales-3-line text-accent-600" aria-hidden="true"></i>
                内容原则
              </h3>
              <ul className="mt-3 space-y-2">
                {editorialRules.map((r) => (
                  <li key={r} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill mt-0.5 text-accent-500" aria-hidden="true"></i>
                    {r}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* right: quote + contact */}
          <div className="flex flex-col gap-5">
            <div className="overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=cheerful%20watermelon%20friends%20grouped%20around%20a%20giant%20shared%20watermelon%20watching%20a%20scoreboard%20together%2C%20community%20spectating%20concept%2C%20coral%20red%20and%20fresh%20green%20on%20warm%20cream%2C%20flat%20vector%20illustration%2C%20warm%20and%20cozy&width=880&height=520&seq=chigua-about-2026&orientation=landscape"
                alt="吃瓜大赛栏目理念：西瓜朋友们围在一起围观计分板"
                className="h-56 w-full object-cover object-top md:h-64"
              />
            </div>

            <div className="rounded-3xl border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base text-foreground-950">
                <i className="ri-quote-text text-primary-500" aria-hidden="true"></i>
                观众怎么说
              </h3>
              <ul className="mt-3 space-y-3.5">
                {quotes.map((q) => (
                  <li key={q.text} className="flex flex-col gap-1 rounded-2xl bg-background-50 px-4 py-3">
                    <p className="text-sm leading-relaxed text-foreground-700">“{q.text}”</p>
                    <span className="text-xs text-foreground-400">—— {q.who}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-4 rounded-3xl bg-secondary-100 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="font-heading text-lg text-foreground-950">有疑问或建议？欢迎来信</h3>
                <p className="mt-1 text-sm text-foreground-600">
                  关于赛程安排、晋级规则、内容反馈，都可以直接联系我们。
                </p>
                <p className="mt-2 flex items-center gap-2 text-sm font-semibold text-foreground-800">
                  <i className="ri-mail-send-line text-secondary-700" aria-hidden="true"></i>
                  <a href="mailto:hello@chigua-dasai.example.com" className="underline-offset-4 hover:underline">
                    hello@chigua-dasai.example.com
                  </a>
                </p>
              </div>
              <a
                href="mailto:hello@chigua-dasai.example.com"
                className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600"
              >
                <i className="ri-chat-1-line text-base" aria-hidden="true"></i>
                联系栏目组
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}